// ============================================================================
// post-client-mod -- useDeletePost Hook
//
// 删除文章的 mutation hook。
// ============================================================================
import { useState, useCallback } from 'react';
import { getPostApiClient } from '../post-api-client.js';
/**
 * 删除文章
 */
export function useDeletePost() {
    const [deleting, setDeleting] = useState(false);
    const [error, setError] = useState(null);
    const deletePost = useCallback(async (id) => {
        setDeleting(true);
        setError(null);
        try {
            await getPostApiClient().deletePost(id);
            return true;
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '删除文章失败';
            setError(message);
            return false;
        }
        finally {
            setDeleting(false);
        }
    }, []);
    const reset = useCallback(() => {
        setError(null);
    }, []);
    return { deleting, error, deletePost, reset };
}
//# sourceMappingURL=use-delete-post.js.map